// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"CovidMap_mapContainer__3vcYc","map":"CovidMap_map__17ZVV"};